// ----
// JS for SCM Pagination.
// ----

var SCM = SCM || {};

SCM.Pagination = (function ($)
{
    return {
        init: init,
        performAjaxPagination: performAjaxPagination,
        updateBrowseHistory: updateBrowseHistory,
        enableBrowserHistoryNavigation: enableBrowserHistoryNavigation,
        trimEndUntilRegexMatches: trimEndUntilRegexMatches,
        scrollToTop: scrollToTop
    };

    function init() {
        if ($('.js-pagination-click').length) {
            $('body').on('click',
                '.js-pagination-click',
                function () {
                    var clickedElem = $(this);

                    var handler = clickedElem.data('click-handler');
                    var parts = handler.split('.');

                    //window[App or SCM][WidgetName][functionName]
                    window[parts[0]][parts[1]][parts[2]](clickedElem);
                });
        }
    }

    function scrollToTop() {
        $(window).scrollTop(0);
    }

    // Assumes the click handler has created the ajaxSettings, and that the clicked Element has been passed back
    function performAjaxPagination(ajaxSettings, clickedElem) {
        var elemLocatorString = clickedElem.data('elem-to-replace');

        if (elemLocatorString) {
            var elementToReplace = $(clickedElem.data('elem-to-replace'));

            if (elementToReplace) {
                $.ajax(ajaxSettings)
                    .done(function(html) {
                        elementToReplace.html(html);
                    })
                    .fail(function(xmlHttpRequest, textStatus, errorThrown) {
                        if (window.console) {
                            // this really helps with debugging during development
                            console.error('error: ' + xmlHttpRequest.responseText);
                            console.error('status: ' + textStatus);
                        }
                    });
            } else {
                alert('Unable to find an element to respond to ajax response.');
            }
        } else {
            alert(
                "The elem-to-replace data attribute was not populated.  You must populate this in the Widget's view to pass back the call to performAjaxPagination");
        }
    }

    // baseUrl is the url of the page if the page number is not included
    // newUrl includes the page number of the pagination element that was just clicked
    function updateBrowseHistory(baseUrl, newUrl) {
        var state = { pagination: newUrl };

        if (history.pushState) {

            // handles the first load of the page
            if (history.state === null || !history.state.pagination) {
                history.replaceState({ pagination: document.URL}, null, document.URL);
            }

        history.pushState(state, null, newUrl);
        }
    }

    // Adds an event listener that will cause the page to reload when pressing the back (or fwd) button.  Only use if you've been updating the browser history
    function enableBrowserHistoryNavigation() {
        window.addEventListener('popstate', function (e) {
            if (e.state && history.state.pagination) {
                window.location = e.state.pagination;
            }
        });
    }

    // convenience method to help trim the baseUrl (in cases where pagination adds a page number to the url)
    function trimEndUntilRegexMatches(url, regex) {
        while (!url.match(regex)) {
            url = url.substr(0, url.length - 1);

            if (url.length === 0) {
                alert('SCM.Pagination.trimEndUntilRegexMatches: ' +
                    'The entire string was trimmed, this likely indicates a problem with your regex pattern.  ' +
                    'Note:  This method expects a regular expression literal (see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions)');
                return '';
            }
        }

        return url;
    }

})(jQuery);

jQuery(function () {
    SCM.Pagination.init();
});